const initialState = {

    //unpicked job order list
    loadingUnpickedJobOrderWithExpenseList: false,
    UnpickedJobOrderWithExpenseList: [],
    UnpickedJobOrderWithExpenseListError: '',
    UnpickedJobOrderWithExpenseListCurrentPage: 0,
    UnpickedJobOrderWithExpenseListTotalPage: 0,
    UnpickedJobOrderWithExpenseListTotalData: 0,
    UnpickedJobOrderWithExpenseListNewJobOrderCount: 0,
    UnpickedJobOrderWithExpenseListPickedJobOrderCount: 0,

    //view job order
    loadingJobOrderDetails: false,
    JobOrderDetailsError: '',
    JobOrderDetails: {},
    JobOrderQuotationDetails: {},
    JobOrderQueryDetails: {},
    JobOrderExpenseList: [],

    //view job order
    loadingExpenseDetails: false,
    ExpenseDetailsError: '',
    ExpenseDetails: {},

    //view expense remarks
    loadingExpenseRemarks: false,
    ExpenseRemarksError: '',
    ExpenseRemarks: [],

}

const AccountReducer = (state = initialState, action) => {
    switch (action.type) {


        //unpicked joborder list//
        case 'FIND_UNPICKED_JOB_ORDER_WITH_EXPENSE_REQUEST':
            return {
                ...state,
                loadingUnpickedJobOrderWithExpenseList: true,
                UnpickedJobOrderWithExpenseList: [],
                UnpickedJobOrderWithExpenseListError: '',
                UnpickedJobOrderWithExpenseListCurrentPage: 0,
                UnpickedJobOrderWithExpenseListTotalPage: 0,
                UnpickedJobOrderWithExpenseListTotalData: 0,
                UnpickedJobOrderWithExpenseListNewJobOrderCount: 0,
                UnpickedJobOrderWithExpenseListPickedJobOrderCount: 0,
            };
        case 'FIND_UNPICKED_JOB_ORDER_WITH_EXPENSE_SUCCESS':
            return {
                ...state,
                loadingUnpickedJobOrderWithExpenseList: false,
                UnpickedJobOrderWithExpenseList: action.payload.data,
                UnpickedJobOrderWithExpenseListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                UnpickedJobOrderWithExpenseListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                UnpickedJobOrderWithExpenseListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
                UnpickedJobOrderWithExpenseListNewJobOrderCount: action.payload.allCounts ? action.payload.allCounts.newJobOrderCount : 0,
                UnpickedJobOrderWithExpenseListPickedJobOrderCount: action.payload.allCounts ? action.payload.allCounts.pickedJobOrderCount : 0,
            };
        case 'FIND_UNPICKED_JOB_ORDER_WITH_EXPENSE_FAILURE':
            return {
                ...state,
                loadingUnpickedJobOrderWithExpenseList: false,
                UnpickedJobOrderWithExpenseListError: action.payload,
                UnpickedJobOrderWithExpenseListCurrentPage: 1,
                UnpickedJobOrderWithExpenseListTotalPage: 0,
                UnpickedJobOrderWithExpenseListTotalData: 0,
                UnpickedJobOrderWithExpenseListNewJobOrderCount: 0,
                UnpickedJobOrderWithExpenseListPickedJobOrderCount: 0,
            };
        //unpicked joborder list//


        //job order details//
        case 'FIND_JOB_ORDER_ACCOUNT_EXPENSE_REQUEST':
            return {
                ...state,
                loadingJobOrderDetails: true,
                JobOrderDetailsError: '',
                JobOrderDetails: {},
                JobOrderQuotationDetails: {},
                JobOrderQueryDetails: {},
                JobOrderExpenseList: [],
            };
        case 'FIND_JOB_ORDER_ACCOUNT_EXPENSE_SUCCESS':
            return {
                ...state,
                loadingJobOrderDetails: false,
                JobOrderDetailsError: '',
                JobOrderDetails: action.payload.data ? action.payload.data.job_order_details : {},
                JobOrderQuotationDetails: action.payload.data ? action.payload.data.quotation_details : {},
                JobOrderQueryDetails: action.payload.data ? action.payload.data.query_details : {},
                JobOrderExpenseList: action.payload.data ? action.payload.data.expense_list : [],
            };
        case 'FIND_JOB_ORDER_ACCOUNT_EXPENSE_FAILURE':
            return {
                ...state,
                loadingJobOrderDetails: false,
                JobOrderDetailsError: action.payload,
                JobOrderDetails: {},
                JobOrderQuotationDetails: {},
                JobOrderQueryDetails: {},
                JobOrderExpenseList: [],
            };
        //job order details//

        //expense details//
        case 'FIND_EXPENSE_REQUEST':
            return {
                ...state,
                loadingExpenseDetails: true,
                ExpenseDetailsError: '',
                ExpenseDetails: {},
            };
        case 'FIND_EXPENSE_SUCCESS':
            return {
                ...state,
                loadingExpenseDetails: false,
                ExpenseDetailsError: '',
                ExpenseDetails: action.payload,
            };
        case 'FIND_EXPENSE_FAILURE':
            return {
                ...state,
                loadingExpenseDetails: false,
                ExpenseDetailsError: action.payload,
                ExpenseDetails: {},
            };
        //expense details//

        //expense details//
        case 'FIND_EXPENSE_REMARKS_REQUEST':
            return {
                ...state,
                loadingExpenseRemarks: true,
                ExpenseRemarksError: '',
                ExpenseRemarks: [],
            };
        case 'FIND_EXPENSE_REMARKS_SUCCESS':
            return {
                ...state,
                loadingExpenseRemarks: false,
                ExpenseRemarksError: '',
                ExpenseRemarks: action.payload,
            };
        case 'FIND_EXPENSE_REMARKS_FAILURE':
            return {
                ...state,
                loadingExpenseRemarks: false,
                ExpenseRemarksError: action.payload,
                ExpenseRemarks: [],
            };
        //expense details//

        default:
            return state;
    }
}

export default AccountReducer;